module.exports = __webpack_public_path__ + "img/image00013-min.99f27ac6.jpeg";